import { useCallback, useMemo } from 'react';

export default function useLayout({ dispatch, value, selectedProperty, isLayoutActive }) {
  const onChange = useCallback(
    (payload) => {
      dispatch({
        type: 'LAYOUT_CHANGE',
        payload
      });
    },
    [dispatch]
  );
  //TODO: Get property type for change layout when user change the property filter
  if (
    isLayoutActive &&
    Boolean(selectedProperty.value) &&
    selectedProperty?.type &&
    value !== selectedProperty.type
  ) {
    onChange(selectedProperty.type);
  }

  return useMemo(() => ({ value, onChange }), [value, onChange]);
}
